module.exports = __webpack_public_path__ + "img/1.1369e6d5.png";